const common = `Session($sessionId: ID!, $filters: SessionParticipantsFilters) {
  session(sessionId: $sessionId) {
    id
    name
    ...Categories
    ...Flag
    ...SectorFlags
    ...Chrono
    ...Weather
    ...Leaderboard
    ...RaceControl
  }
}

fragment Categories on Session {
  categories {
    id
    label
  }
}

fragment Chrono on Session {
  id
  startsAt
  duration
  liveStatus {
    currentFlag {
      type
    }
    isClosed
    stoppedSeconds
    sessionStartTime
    finalDurationSeconds
  }
}

fragment Flag on Session {
  id
  startsAt
  liveStatus {
    sessionStartTime
    currentFlag {
      type
    }
  }
}

fragment SectorFlags on Session {
  sectorFlags {
    sector
    type
  }
}

fragment Weather on Session {
  id
  weather {
    ambientTemperatureEx {
      celsiusDegrees
    }
    humidityPercent
    trackTemperatureEx {
      celsiusDegrees
    }
    pressure {
      mBar
    }
    windSpeed {
      milesPerHour
    }
    windDirectionDegrees
  }
}

fragment Leaderboard on Session {
  id
  chronoType
  participants(filters: $filters) {
    id
    ...LeaderboardParticipant
  }
}

fragment RaceControl on Session {
  id
  raceControl {
    messages {
      id
      text
      dayTime
    }
  }
}

fragment LeaderboardParticipant on SessionParticipant {
  id
  isOut
  ...PositionCell
  ...NumberCell
  ...TeamCell
  ...PicCell
  ...CarCell
  ...TiresCell
  ...LapsCell
  ...GapCell
  ...SectorCell
  ...LastLapCell
  ...BestLapCell
  ...MaxSpeedCell
  ...PitsCell
}

fragment PositionCell on SessionParticipant {
  id
  position
  status
  isOut
  hasSeenCheckeredFlag
}

fragment NumberCell on SessionParticipant {
  id
  number
  category {
    id
  }
}

fragment TeamCell on SessionParticipant {
  id
  team {
    name
  }
  driver {
    id
    firstName
    lastName
  }
}

fragment PicCell on SessionParticipant {
  id
  positionInCategory
  category {
    id
  }
}

fragment CarCell on SessionParticipant {
  id
  car {
    name
  }
}

fragment TiresCell on SessionParticipant {
  id
  tires {
    label
  }
}

fragment LapsCell on SessionParticipant {
  id
  completeLapsCount
}

fragment GapCell on SessionParticipant {
  id
  completeLapsCount
  firstParticipantGap {
    lapNumber
    timeMilliseconds
  }
  previousParticipantGap {
    type
    lapDifference
    timeMilliseconds
  }
}

fragment SectorCell on SessionParticipant {
  id
  lastCompletedSectors {
    lapTime
    state
  }
}

fragment LastLapCell on SessionParticipant {
  id
  lastLap {
    timeMilliseconds
    state
  }
}

fragment BestLapCell on SessionParticipant {
  id
  bestLap {
    timeMilliseconds
    state
  }
}

fragment MaxSpeedCell on SessionParticipant {
  id
  bestTopSpeedKMH
}

fragment PitsCell on SessionParticipant {
  id
  pitStopCount
}`

export const sessionSubscription = `subscription ${common}`;
export const sessionQuery = `query ${common}`;

export const sessionLayoutQuery = `
query SessionLayout($raceId: ID!) {
  race(raceId: $raceId) {
    id
    name
    sessions {
      id
      closed
      name
      startsAt
      endsAt
    }
  }
}`;
